var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"flat":"","height":"67vh"}},[_vm._v("\n  trash\n\n")])}
var staticRenderFns = []

export { render, staticRenderFns }